import React, { useMemo, useState } from 'react';
import { CommodityManagementSiteAccessModel, GetCustomerDataResponse, GetCustomerSettingsResponse } from '../../../../Generated/Commodity-Management-Api';
import { RootState, useApplicationSelector } from '../../../../Redux/ReduxStore';
import { StoneXTab, StoneXTabs } from '../../../StoneX';
import StoneXMainPage from '../../../StoneX/StoneXMainPage/StoneXMainPage';
import CounterpartySettings from './CounterpartySettings';
import OrganizationSettings from './OrganizationSettings';
import PortfolioSettings from './PortfolioSettings';
import UserManagementAdminSettings from './UserManagementAdminSettings';
import { UserAccessState } from '../../../../Redux/Slices/UserAccessSlice';
import PricingStrategySettings from './PricingStrategySettings';
import CommoditySettings from './CommoditySettings';
import CustomerSettings from './CustomerSettings';
import ReportSettings from './ReportSettings/ReportSettings';

export default function SettingsPage() {

  const userAccess = useApplicationSelector((state: RootState): UserAccessState => state.userAccess);
  const activeSite = useApplicationSelector((state: RootState): CommodityManagementSiteAccessModel => state.activeSite.site);
  const customerData = useApplicationSelector((state: RootState): GetCustomerDataResponse => state.commodityManagement.customerData);
  const customerSettings = useApplicationSelector((state: RootState): GetCustomerSettingsResponse => state.commodityManagement.customerSettings);

  const showCounterparties = (customerSettings?.budgetsByCounterparty ?? false) || (customerSettings.positionsByCounterparty ?? false);
  const showPortfolios = customerSettings.budgetsByPortfolio || customerSettings.positionsByPortfolio;
  const showOrganization = customerSettings.budgetsByLocation || customerSettings.positionsByLocation;
  const showUserManagement = activeSite.isSiteManager || userAccess.isAdmin;
  const showCommodities = userAccess.isAdmin;
  const showPricingStrategies = userAccess.isAdmin;
  const showCustomerSettings = userAccess.isAdmin;
  const showReportSettings = userAccess.isAdmin;

  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

  const tabs = useMemo(() => {

      const tabOptions = [
      showCustomerSettings ? { label: 'Customer Settings', content: <CustomerSettings /> } : null,
      showReportSettings ? { label: 'Report Settings', content: <ReportSettings /> } : null,
      showCommodities ? { label: 'Commodities', content: <CommoditySettings commodities={customerData?.commodities!} /> } : null,
      showPricingStrategies ? { label: 'Pricing Strategies', content: <PricingStrategySettings /> } : null,
      showCounterparties ? { label: 'Counterparties', content: <CounterpartySettings counterparties={customerData?.counterparties!} /> } : null,
      showPortfolios ? { label: 'Portfolios', content: <PortfolioSettings portfolios={customerData?.portfolios!} /> } : null,
      showOrganization ? { label: 'Organization', content: <OrganizationSettings tiers={customerData?.tiers!} locations={customerData?.locations!} /> } : null,
      showUserManagement ? { label: 'User Management', content: <UserManagementAdminSettings /> } : null,
    ].filter(tab => tab !== null);

    return tabOptions;

  }, [customerData, userAccess, activeSite, customerSettings]);

  const pageStyle = {
    margin: '20px',
  };

  function handleTabChange(newIndex: number) {
    setActiveTabIndex(newIndex);
  }

  return (
    <StoneXMainPage>
      <StoneXTabs>
        {tabs.map((tab, index) => <StoneXTab key={index} label={tab!.label} onClick={() => handleTabChange(index)} isActive={activeTabIndex == index}/>)}
      </StoneXTabs>

      {tabs.map((tab, idx) => (
      <div
        key={idx}
        style={{
        display: activeTabIndex === idx ? 'flex' : 'none',
        flexGrow: 1,
        flexDirection: 'column',
        ...pageStyle,
        }}
      >
        {tab!.content} 
      </div>
      ))}
    </StoneXMainPage>
  );
}